// todo: remove lodash on client
import startCase from 'lodash/startCase';
import { useMemo } from 'react';

import { US_COUNTRY_CODE } from '@glass/common/modules/geo/data/countries';
import filterJoin from '@glass/common/modules/strings/filterJoin';

import { CONTEXT_KEY, SCHEMA_TYPE, TYPE_KEY } from '@glass/shared/modules/jsonLd/constants/common';

const useOccupationSalaryJsonLd = ({ name, salary, location }) => {
  const { updatedAt, min, max, average, city, state, type } = salary || {};
  return useMemo(() => {
    if (!salary) {
      return {};
    }
    const occupationLocation = [];

    if (type === 'area' && state) {
      if (city) {
        occupationLocation.push({
          [TYPE_KEY]: 'City',
          name: filterJoin([startCase(city), state.toUpperCase(), US_COUNTRY_CODE]),
        });
      } else {
        occupationLocation.push({
          [TYPE_KEY]: 'State',
          name: filterJoin([state.toUpperCase(), US_COUNTRY_CODE]),
        });
      }
    } else {
      occupationLocation.push({
        [TYPE_KEY]: 'Country',
        name: US_COUNTRY_CODE,
      });
    }

    const percentile25 = 15 * ((average - min) / (50 - 10)) + min;
    const percentile75 = 25 * ((max - average) / (90 - 50)) + average;

    return {
      [CONTEXT_KEY]: SCHEMA_TYPE,
      [TYPE_KEY]: 'Occupation',
      name,
      description: `Salary range and resumes for ${name} in ${location}`,
      mainEntityOfPage: {
        [TYPE_KEY]: 'WebPage',
        lastReviewed: updatedAt,
      },
      estimatedSalary: [
        {
          [TYPE_KEY]: 'MonetaryAmountDistribution',
          name: 'base',
          currency: 'USD',
          percentile10: min,
          percentile25,
          median: average,
          percentile75,
          percentile90: max,
        },
      ],
      occupationLocation,
    };
  }, [salary, city, state, name, location, updatedAt, min, max, average, type]);
};

export default useOccupationSalaryJsonLd;
